var render = function render(){var _vm=this,_c=_vm._self._c;return _c('toggle',{attrs:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}},scopedSlots:_vm._u([{key:"active",fn:function(){return [_c('Check')]},proxy:true},{key:"inactive",fn:function(){return [_c('TextBoxSearch')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }